import { LocaleCodeSchema } from "@shared/schemas/locale.schemas";
import type {
  LocaleCode,
  SupportedTranslationLocale,
} from "@shared/schemas/locale.schemas";
import {
  resolveEventLocale,
  resolveSupportedLocale,
} from "@shared/utils/locale-resolution.utils";

export function readBrowserLocale(): LocaleCode | null {
  if (typeof navigator === "undefined") {
    return null;
  }
  const parsed = LocaleCodeSchema.safeParse(navigator.language.split("-")[0]);
  return parsed.success ? parsed.data : null;
}

/**
 * Rule 4: the candidate decides, clamped to the event. With no event to clamp to
 * this is Rule 5. Anonymous surfaces pass the browser locale; authenticated ones
 * pass the member's `preferredLocale` — the same value Porter resolves for them,
 * so chat and pages cannot disagree. The browser is deliberately NOT consulted
 * for a member: one who talks to Porter in Spanish from an `en-US` browser reads
 * Spanish pages.
 */
export function resolveLocaleFrom(
  candidate: LocaleCode | null,
  eventLanguages?: readonly [
    SupportedTranslationLocale,
    ...SupportedTranslationLocale[],
  ],
): SupportedTranslationLocale {
  return eventLanguages === undefined
    ? resolveSupportedLocale([candidate])
    : resolveEventLocale(candidate, eventLanguages);
}

/**
 * Rule 4-anonymous: the browser decides, clamped to the event. With no event to
 * clamp to this is Rule 5.
 */
export function resolveLocale(
  eventLanguages?: readonly [
    SupportedTranslationLocale,
    ...SupportedTranslationLocale[],
  ],
): SupportedTranslationLocale {
  return resolveLocaleFrom(readBrowserLocale(), eventLanguages);
}
